module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "name": "top"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "toTop",
    style: ({
      right: _vm.topRight + 'px'
    }),
    attrs: {
      "href": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/top.png"),
      "alt": "返回顶部"
    }
  })]), _vm._v(" "), _c('my-menu', {
    attrs: {
      "menu-name": "discovery"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c_content clearfix"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("\n        当前位置：\n      ")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Discovery'
      }
    }
  }, [_vm._v("发现")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "sep active"
  }, [_vm._v("\n        正文\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "c_detail"
  }, [_c('h1', [_vm._v(_vm._s(_vm.class_detail.title))]), _vm._v(" "), _c('span', {
    staticClass: "c_from"
  }, [_vm._v(_vm._s(_vm.class_detail.date) + " 来源：维克多英语")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.class_detail.content)
    }
  })]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "3px",
      "background-color": "#333",
      "width": "100%''"
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sep"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("维学课堂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend clearfix"
  }, [_c('h2', [_vm._v("精彩推荐")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态用法详解\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态用法详解\n          ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98fe5322","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Discovery/ClassDetail.vue
// module id = 92
// module chunks = 0